module.exports = __webpack_public_path__ + "media/images/medicday-239b5605a14ddc4fe413eace2132b998.jpg";